/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { QuestionnaireImportance } from "@/pages/Public/pages/Questionnaire/enum/QuestionnaireImportance.enum";

import { Button } from "@/components/Button/Button";

import { Icon } from "@/components";

import FormLabel from "../../../ToDo/ManageToDos/components/EditableToDoItem/FormLabel";
import StepOptionItem from "./StepOptionItem";

interface StepOptionsFactoryProps {
	className?: string;
	fields: { id: string }[];
	register: UseFormRegister<any>;
	setValue: UseFormSetValue<any>;
	watch: UseFormWatch<any>;
	errors?: FieldErrors;
	removeItem?: (id: number) => void;
}

export default function StepOptionsFactory({
	className,
	fields,
	register,
	watch,
	errors,
	removeItem,
	setValue,
}: StepOptionsFactoryProps) {
	const { t } = useTranslation();
	const ts = (key: string, options = {}) => t(`manage-questionnaire.${key}`, options);

	return (
		<div className={`space-y-5 ${className}`}>
			{fields.map((item, index) => (
				<div key={item.id} className="grid grid-cols-8">
					<FormLabel
						className="mt-4 col-span-2"
						title={ts("form-fields.answer-number", { number: index + 1 })}
					/>

					<div className="col-span-6 flex w-full gap-2">
						<StepOptionItem
							className="w-full space-y-4"
							error={errors && Array.isArray(errors) ? errors[index] : undefined}
							nameImportance={`options.${index}.type`}
							nameTitle={`options.${index}.title`}
							register={register}
							setValue={setValue}
							valueImportance={watch(`options.${index}.type`) as QuestionnaireImportance}
						/>

						<Button
							className="rounded-[12px] bg-white !min-w-[44px] !min-h-[44px] !max-w-[44px] !max-h-[44px] !p-0 !border-[0.28px] !border-[#E6E6EC] hover:bg-primary-gray-lightest"
							image={<Icon className="text-primary-blue-dark w-5 h-5" icon={faTrashCan} />}
							title=""
							type="button"
							onClick={() => {
								removeItem?.(index);
							}}
						/>
					</div>
				</div>
			))}
		</div>
	);
}
